import { Outlet, Link } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { apiUrl } from '../../lib/config';

export default function Layout() {
  const { character, isAuthenticated, isAdmin, logout } = useAuthStore();

  return (
    <div className="flex h-full flex-col">
      {/* Header */}
      <header className="flex items-center justify-between border-b border-gray-700 bg-gray-800 px-4 py-3">
        <div className="flex items-center gap-6">
          <Link to="/" className="text-xl font-bold text-white">
            WH Mapper
          </Link>
          {isAuthenticated && (
            <nav className="flex gap-4">
              <Link
                to="/dashboard"
                className="text-gray-300 transition hover:text-white"
              >
                Dashboard
              </Link>
              {isAdmin && (
                <Link
                  to="/admin"
                  className="text-yellow-400 transition hover:text-yellow-300"
                >
                  Admin
                </Link>
              )}
            </nav>
          )}
        </div>

        <div className="flex items-center gap-4">
          {isAuthenticated && character ? (
            <>
              <span className="text-gray-300">{character.name}</span>
              <button
                onClick={logout}
                className="rounded bg-gray-700 px-3 py-1 text-sm text-gray-300 transition hover:bg-gray-600"
              >
                Logout
              </button>
            </>
          ) : (
            <a
              href={apiUrl('/api/auth/login')}
              className="rounded bg-blue-600 px-3 py-1 text-sm text-white transition hover:bg-blue-700"
            >
              Login
            </a>
          )}
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
